// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__Z3DLR","card":"HomePage_card__X+czq"};